import { observer } from 'mobx-react-lite'
import { InputRadio, TextareaWithLabel, Typography } from 'shared/ui'
import { type DowngradeContentStore } from 'pages/settings/pages/billing/pages/upgrade/store/downgradeContentStore'
import styles from './styles.module.scss'

const reasons = [
  'I was on the wrong plan',
  'I can no longer afford it / budget reasons',
  'My business is seasonal',
  "I didn't use the credits",
  'Too many credits',
  'Other',
]

type IDowngradeContentProps = {
  store: DowngradeContentStore
}

export const DowngradeContent = observer(({ store }: IDowngradeContentProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.reasonsWrapper}>
        <Typography
          ariaLabel='downgrade_content_title'
          variant='text-input-label-small'
          color='var(--content-primary-tertiary)'
          tag='div'
          marginBottom={8}
          marginTop={4}
        >
          {"We'd like to know why you're downgrading"}
        </Typography>
        <div className={styles.reasonsContainer}>
          {reasons.map((reason) => (
            <InputRadio
              key={reason}
              radioSize='small'
              checked={store.selectedReason === reason}
              onChecked={() => store.setSelectedReason(reason)}
              label={reason}
            />
          ))}
        </div>
      </div>
      {store.selectedReason && (
        <TextareaWithLabel
          labelProps={{
            label: {
              text: 'Is there anything else we should know?',
              secondaryText: '(optional)',
            },
          }}
          value={store.reasonDesc}
          placeholder='Type here...'
          onChange={store.setReasonDesc}
        />
      )}
    </div>
  )
})
